import { createNamespacer, createReducer } from "../commons/js/utils/reducer"

const initialState = {
    loading: false,
    clients: [],
    pageCount: 1,
    currentPage: 1,
}

const namespacer = createNamespacer("CLIENT_DASHBOARD");

const ClientDashboardReducer = createReducer(initialState, {
    [namespacer("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            loading: action.payload.value,
        }
    },
    [namespacer("SET_CLIENTS_DATA")]: (state, action) => {
        return {
            ...state,
            clients: action.payload.value,
            pageCount: action.payload.totalPages,
            currentPage: action.payload.currentPage,
        }
    }
})

export default ClientDashboardReducer;